<div class="flex flex-col gap-2">
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      @if (titleTemplate) {
        <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
      } @else if (titleText) {
        <span class="font-bold text-sm">{{ titleText }}</span>
      }
      @if (headerTemplate && headerTemplateInlineLeft) {
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      }
    </div>
    <div class="flex items-center gap-2">
      @if (headerTemplate && !headerTemplateInlineLeft) {
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      }
      @if (hasOverflow && isBrowser) {
        <button
          type="button"
          class="inline-flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-800 transition disabled:cursor-not-allowed disabled:opacity-40"
          (click)="moveLeft()"
          [disabled]="isScrollAtStart"
          aria-label="Move the slider left"
        >
          <i class="pi pi-arrow-left"></i>
        </button>
        <button
          type="button"
          class="inline-flex h-11 w-11 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-800 transition disabled:cursor-not-allowed disabled:opacity-40"
          (click)="moveRight()"
          [disabled]="isScrollAtEnd"
          aria-label="Move the slider right"
        >
          <i class="pi pi-arrow-right"></i>
        </button>
      }
    </div>
  </div>
  <div class="flex flex-nowrap overflow-x-scroll no-scrollbar select-none touch-pan-x {{ itemGapClass }} {{ sliderClass }}" #slider>
    @for (item of items; track item) {
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: { $implicit: item }">
      </ng-container>
    }
  </div>
</div>